import React, {useEffect, useState} from "react";
import {useLocation, useNavigate} from "react-router-dom";
import {confirmPasswordReset} from "firebase/auth";
import {auth} from "../firebaseConfig";
import {Box, Button, Paper, Stack, TextField, Typography} from "@mui/material";
import medendoLogo from "../assets/medendo_logo.png";


const PasswordSetupStep: React.FC = () => {
    const [newPassword, setNewPassword] = useState("");
    const [error, setError] = useState<string | null>(null);
    const [success, setSuccess] = useState(false);
    const location = useLocation();
    const navigate = useNavigate();

    useEffect(() => {
        const queryParams = new URLSearchParams(location.search);
        const oobCode = queryParams.get("oobCode");

        if (!oobCode) {
            setError("Invalid or missing code.");
        }
    }, [location.search]);

    const handlePasswordReset = async () => {
        const queryParams = new URLSearchParams(location.search);
        const oobCode = queryParams.get("oobCode");

        if (!oobCode) {
            setError("Invalid or missing code.");
            return;
        }

        try {
            await confirmPasswordReset(auth, oobCode, newPassword);
            setSuccess(true);
            console.info("Password reset confirmed successfully.");
        } catch (error) {
            console.warn("Failed to confirm password reset:", error);
            setError("Er is een fout opgetreden bij het resetten van je wachtwoord.");
        }
    };

    return (
        <Box
            sx={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '100vh',
            }}
        >
            <Paper>
                <Stack width={400} p={2}>
                    <Box sx={{display: 'flex', justifyContent: 'center'}}>
                        <img src={medendoLogo} alt="Logo" width={200}/>
                    </Box>
                    <Box sx={{display: 'flex', justifyContent: 'center'}}>
                            <Stack>
                                {error && <Typography color="error">Het is niet gelukt om je wachtwoord te
                                    resetten.</Typography>}
                                {success ? (
                                    <>
                                        <Typography color="success">Je kunt nu inloggen met je nieuwe
                                            wachtwoord.</Typography>
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={() => navigate("/")}
                                        >
                                            naar de inlog pagina
                                        </Button>
                                    </>
                                ) : (
                                    <>
                                        <Typography variant="h6">Kies een nieuw wachtwoord</Typography>
                                        <TextField
                                            type="password"
                                            label="Voer een nieuw wachtwoord in"
                                            variant="outlined"
                                            value={newPassword}
                                            fullWidth
                                            onChange={(e) => setNewPassword(e.target.value)}
                                        />
                                        <Button
                                            variant="contained"
                                            color="primary"
                                            onClick={handlePasswordReset}
                                            disabled={!newPassword}
                                        >
                                            Wachtwoord instellen
                                        </Button>
                                    </>
                                )}
                            </Stack>
                    </Box>

                </Stack>
            </Paper>
        </Box>
    );
};

export default PasswordSetupStep;